import secureLocalStorage from "react-secure-storage";
import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
import { filterBy } from "@progress/kendo-data-query";
export default class TaskCustomFieldSingleDropdown extends GridCell {
  constructor(props) {
    super(props);
    this.state = {
      dropdownListData: [],
      dropdownListDataTemp:[]
    };
  }
  componentDidMount() {
    if (this.props.customFieldsData) {
      this.initLoadData();
    }
  }

  initLoadData = () => {
    try {
      let customFields = this.props.customFieldsData;
      let field = this.props.field;
      let options = customFields.find((item) => item.fieldName == field);
      if (options && options.cfPossibleValues) {
        this.setState({
          ...this.state,
          dropdownListData: options.cfPossibleValues,
          dropdownListDataTemp:options.cfPossibleValues,
        });       
      }
    } catch (err) {}
  };

  handleChange = (event) => {
    try {
      let customFields = this.props.customFieldsData;
      let field = this.props.field;
      let options = customFields.find((item) => item.fieldName == field);

      if (options && options.cfPossibleValues) {
        let val = {
          ...this.props.dataItem,
          taskCustomField: {
            CustomFieldId: options.id,
            inputType: "Single Drop Down",
            SingleDropDownValue: event.target.value,
          },
        };
        this.props.manageCustomValues(val);
      }
    } catch (err) {}
  };
  handleEditCell = () => {
    if(this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open"){
      this.props.onEditCell(
        this.props.dataItem,
        this.props.field,
        this.props.stateData
      );
    }
  };
  handlefilter = (e) => {
    const filteredvalue = filterBy(this.state.dropdownListDataTemp, e.filter);

    this.setState({
      dropdownListData: filteredvalue,
    });
  };
  getSortedList = () => {

    let sortedlist = this.state.dropdownListData.sort(function (a, b) {
      if (a.possibleValues < b.possibleValues) {
        return -1;
      }
      if (a.possibleValues > b.possibleValues) {
        return 1;
      }
      return 0;
    });
    return sortedlist;
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const value = this.props.dataItem[this.props.field];
    const cf =
      this.props.dataItem.customFields &&
      this.props.dataItem.customFields.find(
        (item) => item.fieldName == this.props.field
      );
    let access = false;
    if (cf) {
      access = true;
    }

    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <DropDownList
            style={{ width: "100px" }}
            onChange={this.handleChange.bind(this)}
            // value={selectedValue ? selectedValue : value}
            data={this.getSortedList()}
            valueField="id"
            textField="possibleValues"
            filterable={true}
            onFilterChange={(e) => this.handlefilter(e)}
            opened={true}
          />
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if (loginUserId === ownerId && access) {
        return <td onClick={this.handleEditCell}>{value}</td>;
      } else {
        return this.props.dataItem.roleName == "Standard User" ||
          this.props.dataItem.roleName == "View Only" ||
          !access ? (
          <td>{value}</td>
        ) : (
          <td onClick={this.handleEditCell}>{value}</td>
        );
      }
    }
  }
}
